import useQuery from './useQuery';

const baseUrl = '/users/me/';

function useMeQuery(params) {
  return useQuery(baseUrl, { staleTime: 60 * 1000, ...params });
}

export default useMeQuery;
